export const setCompAllGroupAction = status => ({
  type: 'SET_COMP_ALL_GROUPS',
  payload: status,
});

export const setVenueAvailableAction = status => ({
  type: 'SET_VENUE_AVAILABLE',
  payload: status,
});

export const setActiveMarketplacesAction = status => ({
  type: 'SET_ACTIVE_MARKETPLACES',
  payload: status,
});

export const setEventAction = status => ({
  type: 'SET_EVENT',
  payload: status,
});

export const setMarkeplaceFilteredListings = listings => ({
  type: 'SET_MARKETPLACE_FILTERED_LISTINGS',
  payload: listings,
});
